export default "__VITE_ASSET__ClNshCYu__"